var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuItemText = void 0;
var MenuItemText_1 = __importDefault(require("./MenuItemText"));
exports.MenuItemText = MenuItemText_1.default;
exports.default = MenuItemText_1.default;
//# sourceMappingURL=index.js.map